import { createStyles, makeStyles } from "@material-ui/core";
import { Divider, Grid, Stack, Typography } from "@mui/material";
import { useContext } from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useParams } from "react-router-dom";
import { CurrencyContext } from "../../../../contexts/AppContext";
import logo from "../../../../images/africa_pnb_logo.png";
import {
    ConvertedDeviseWithMoneySign,
    ConvertedDeviseWithoutMoneySign,
} from "../../../../utils/CurrencyConvertFunction";
import {
    dohoneRefundTravellerDefaultValue,
    refundTravellerDefaultValue,
    transactionReqDefaultValue,
} from "../../../../utils/defaultNullValues";
import { ITransactionReq } from "../../../../utils/PaymentInterfaces";
import { ConfirmationReservationService } from "../../services/ConfirmationReservationService";
import React from "react";
import {
    dateToStringDDMMYYYY,
    getDayNumber,
    getDayNumberProm,
    getPrestayPassedNumberFact,
    getRefundTypeFact,
} from "../../../../utils/App";
import moment from "moment";
import { EStatus, ETarifs, getTarifLabel } from "../../../../utils/enum";
import { PropagateLoader } from "react-spinners";
import { ERefundType } from "../../../../utils/enum/RefundType";
import {
    EPaymentMethod,
    ETransactionType,
} from "../../../../utils/enum/PaymentMethod";
import { UserReservationService } from "../../../UserAdmin/UserReservations/services/UserReservationService";
import {
    DohonePayoutMode,
    IRefund,
    IRefundDohone,
} from "../../../../utils/PaymentInterfaces";
const userReservService = new UserReservationService();
const confirmServ = new ConfirmationReservationService();
export function ReceiptReservation() {
    const [penaltyDaysFees, setPenaltyDaysFees] = React.useState<number>(0);
    const [refundTravellerDohone, setRefundTravellerDohone] =
        React.useState<IRefundDohone>(dohoneRefundTravellerDefaultValue);
    const [, setTravellerAmount] = React.useState<number>(0);
    const [reversalFeesAmount, setReversalFeesAmount] =
        React.useState<number>(0);
    const [travellerRefundFinal, setTravellerRefundFinal] =
        React.useState<number>(0);
    const [refundTraveller, setRefundTraveller] = React.useState<IRefund>(
        refundTravellerDefaultValue
    );
    const [travellerPaymentAccount] = React.useState<string>("");
    const [loadingPage, setLoadingPage] = React.useState<boolean>(true);
    const [transaction, setTransaction] = React.useState<ITransactionReq>(
        transactionReqDefaultValue
    );
    const [refundedTransactonId, setRefundedTransactionId] =
        React.useState<string>("");
    const [refundedTransactonCreatedAt, setRefundedTransactionCreatedAt] =
        React.useState<Date>(new Date());
    const [refundedTransactonPaymentID, setRefundedTransactionPaymentID] =
        React.useState<string>("");
    const params: { id: string } = useParams();
    const currencyContext = useContext(CurrencyContext);
    const [, setCommissionFee] = React.useState<number>(0);
    const [priceConverted, setPriceConverted] = React.useState<number>(0);
    const [, setPriceBookingconverted] = React.useState<number>(0);
    const [priceServiceConverted, setPriceServiceconverted] =
        React.useState<number>(0);
    const [priceConvertedProm, setPriceConvertedProm] =
        React.useState<number>(0);
    const [totalPriceProm, setTotalPriceProm] = React.useState<number>(0);
    const [totalPriceSimple, setTotalPriceSimple] = React.useState<number>(0);
    const [priceConvertedFinal, setPriceConvertedFinal] =
        React.useState<number>(0);
    const [
        priceConvertedFinalFromTransaction,
        setPriceConvertedFinalFromTransaction,
    ] = React.useState<number>(0);
    const [
        priceCreditFromTransaction,
        setPriceCreditFromTransaction,
    ] = React.useState<number>(0);
    const [cleaningFees, setCleaningFees] = React.useState<number>(0);
    const [nbJourProm, setNbJourProm] = React.useState(0);
    const [nbJourSimple, setNbJourSimple] = React.useState(0);
    const [promotionRate, setPromotionRate] = React.useState(0);
    const [priceWithoutCleaningFees, setPriceWithoutCleaningFees] =
        React.useState(0);
    const [travellerPaymentMethodFee, setTravellerPaymentMethodFee] =
        React.useState<number>(0);
    const [services, setServices] = React.useState<any[]>([]);
    const [travellerPaymentMethod, setTravellerPaymentMethod] = React.useState(
        EPaymentMethod.Paypal
    );
    const [passedDaysFees, setPassedDaysFees] = React.useState<number>(0);
    const [, setTravellerInitialRefundValue] = React.useState<number>(0);
    const [tarif, setTarif] = React.useState(ETarifs.JOURNALIER);
    const [isCancellation, setIsCancellation] = React.useState<Boolean>(false);
    const [paymentID, setPaymentID] = React.useState<string>("");
    const { currency } = currencyContext;
    const { t } = useTranslation();
    const location = useLocation();
    const classes = style();
    // console.log("okokok", user);
    React.useEffect(() => {
        let nbjours_prom: number;
        let nbjours_simple: number;
        let nbJour: number;
        confirmServ
            .getTransactionDetailByReservationId(params.id)
            .then((response) => {
                if (response.success) {
                    let transaction = response.data;
                    //console.log("Transaction object ReceiptReservation:", transaction); 
                    const reservation = transaction.reservation;
                    const announce = transaction.reservation.announce;
                    const promotion = transaction.reservation.promotion;
                    setServices(reservation.services);
                    setTransaction(transaction);
                    setPaymentID(
                        transaction.type === ETransactionType.Sending
                            ? transaction.orderID
                            : transaction.paymentID ?? ""
                    );
                    setTravellerPaymentMethod(transaction.method);
                    if (
                        reservation.status[reservation.status.length - 1]
                            .status === EStatus.CANCELLED ||
                        reservation.status[reservation.status.length - 1]
                            .status === EStatus.CANCELLED_BY_ADMIN ||
                        reservation.status[reservation.status.length - 1]
                            .status === EStatus.REJECTED
                    ) {
                        confirmServ
                            .getTransactionIdByRefundedReservationId(params.id)
                            .then((response) => {
                                setRefundedTransactionCreatedAt(
                                    response.data.createdAt
                                );
                                setRefundedTransactionPaymentID(
                                    response.data.paymentID
                                );
                                setRefundedTransactionId(response.data._id);
                            })
                            .catch((error) => {
                                console.log(error);
                            });
                    }
                    if (promotion) {
                        nbjours_prom = getDayNumberProm(
                            moment(reservation.dateCheckIn).format(
                                "YYYY-MM-DD"
                            ),
                            moment(reservation.dateCheckOut).format(
                                "YYYY-MM-DD"
                            ),
                            moment(promotion.startDate).format("YYYY-MM-DD"),
                            moment(promotion.endDate).format("YYYY-MM-DD"),
                            announce.price,
                            promotion.price
                        ).DateProm;
                        nbjours_simple = getDayNumberProm(
                            moment(reservation.dateCheckIn).format(
                                "YYYY-MM-DD"
                            ),
                            moment(reservation.dateCheckOut).format(
                                "YYYY-MM-DD"
                            ),
                            moment(promotion.startDate).format("YYYY-MM-DD"),
                            moment(promotion.endDate).format("YYYY-MM-DD"),
                            announce.price,
                            promotion.price
                        ).DateSimple;
                        nbJour = nbjours_simple + nbjours_prom;
                        setNbJourSimple(nbjours_simple);
                        setNbJourProm(nbjours_prom);
                        setPromotionRate(promotion.discount);
                    }

                    if (
                        transaction.reservation.announce?.property?.type
                            .name === "Hôtel"
                    ) {
                        confirmServ
                            .getSpecialFeeByPropertyType(
                                transaction.reservation.announce?.property?.type
                                    .name
                            )
                            .then((respCom) => {
                                if (respCom.success) {
                                    const percentage = respCom.data
                                        ? respCom.data.percentageTraveller
                                        : 0;
                                    setCommissionFee(percentage);
                                    let priceProm;
                                    let priceNorm;
                                    let totalPriceProm;
                                    let totalPriceNorm;
                                    let priceWithDaysWithCleanningAndCmomission: number;
                                    let announceCleaningFees: number;
                                    let _bookingPrice = Number(
                                        (reservation.detailAnnouce
                                            ? reservation.detailAnnouce.price +
                                              reservation.detailAnnouce.price *
                                                  (percentage / 100)
                                            : reservation.announce.price +
                                              reservation.announce.price *
                                                  (percentage / 100)
                                        ).toFixed(2)
                                    );
                                    if (promotion) {
                                        priceProm = Number(
                                            (
                                                promotion.price +
                                                promotion.price *
                                                    (percentage / 100)
                                            ).toFixed(2)
                                        );

                                        if (
                                            nbJour >= 7 &&
                                            nbJour < 14 &&
                                            reservation.announce.priceWeekly &&
                                            reservation.announce.priceWeekly > 0
                                        ) {
                                            priceNorm = Number(
                                                reservation.detailAnnouce
                                                    ? (
                                                          reservation
                                                              .detailAnnouce
                                                              .priceWeekly /
                                                              7 +
                                                          (reservation
                                                              .detailAnnouce
                                                              .priceWeekly /
                                                              7) *
                                                              (percentage / 100)
                                                      ).toFixed(2)
                                                    : (
                                                          reservation.announce
                                                              .priceWeekly /
                                                              7 +
                                                          (reservation.announce
                                                              .priceWeekly /
                                                              7) *
                                                              (percentage / 100)
                                                      ).toFixed(2)
                                            );
                                            setTarif(ETarifs.HEBDOMADAIRE);
                                        } else if (
                                            nbJour >= 14 &&
                                            nbJour < 30 &&
                                            reservation.announce
                                                .priceBiWeekly &&
                                            reservation.announce.priceBiWeekly >
                                                0
                                        ) {
                                            priceNorm = Number(
                                                reservation.detailAnnouce
                                                    ? (
                                                          reservation
                                                              .detailAnnouce
                                                              .priceBiWeekly /
                                                              14 +
                                                          (reservation
                                                              .detailAnnouce
                                                              .priceBiWeekly /
                                                              14) *
                                                              (percentage / 100)
                                                      ).toFixed(2)
                                                    : (
                                                          reservation.announce
                                                              .priceBiWeekly /
                                                              14 +
                                                          (reservation.announce
                                                              .priceBiWeekly /
                                                              14) *
                                                              (percentage / 100)
                                                      ).toFixed(2)
                                            );
                                            setTarif(ETarifs.QUINZAINE);
                                        } else if (
                                            nbJour >= 30 &&
                                            reservation.announce.priceMonthly &&
                                            reservation.announce.priceMonthly >
                                                0
                                        ) {
                                            priceNorm = Number(
                                                reservation.detailAnnouce
                                                    ? (
                                                          reservation
                                                              .detailAnnouce
                                                              .priceMonthly /
                                                              30 +
                                                          (reservation
                                                              .detailAnnouce
                                                              .priceMonthly /
                                                              30) *
                                                              (percentage / 100)
                                                      ).toFixed(2)
                                                    : (
                                                          reservation.announce
                                                              .priceMonthly /
                                                              30 +
                                                          (reservation.announce
                                                              .priceMonthly /
                                                              30) *
                                                              (percentage / 100)
                                                      ).toFixed(2)
                                            );
                                            setTarif(ETarifs.MENSUEL);
                                        } else {
                                            priceNorm = Number(
                                                (reservation.detailAnnouce
                                                    ? reservation.detailAnnouce
                                                          .price +
                                                      reservation.detailAnnouce
                                                          .price *
                                                          (percentage / 100)
                                                    : reservation.announce
                                                          .price +
                                                      reservation.announce
                                                          .price *
                                                          (percentage / 100)
                                                ).toFixed(2)
                                            );
                                            setTarif(ETarifs.JOURNALIER);
                                        }
                                        totalPriceProm =
                                            priceProm * nbjours_prom;
                                        totalPriceNorm =
                                            priceNorm * nbjours_simple;
                                        priceWithDaysWithCleanningAndCmomission =
                                            totalPriceNorm +
                                            totalPriceProm +
                                            (reservation.detailAnnouce ? (reservation.detailAnnouce.cleaningFees +
                                                reservation.detailAnnouce.cleaningFees *
                                                    (percentage / 100)) : (announce.cleaningFees +
                                                announce.cleaningFees *
                                                    (percentage / 100)));
                                        const totalService =
                                            transaction.reservation.services
                                                .length > 0
                                                ? transaction.reservation.services.reduce(
                                                      (
                                                          prev: any,
                                                          service: any
                                                      ) => prev + service.price,
                                                      0
                                                  )
                                                : 0;
                                        announceCleaningFees =
                                            announce.cleaningFees +
                                            announce.cleaningFees *
                                                (percentage / 100);
                                        ConvertedDeviseWithMoneySign(
                                            announce.devise,
                                            currency,
                                            priceNorm
                                        )
                                            .then((value: any): any => {
                                                setPriceConverted(value);
                                            })
                                            .catch((error) =>
                                                console.log(error)
                                            );
                                        ConvertedDeviseWithMoneySign(
                                            announce.devise,
                                            currency,
                                            priceProm
                                        ).then((value: any): any => {
                                            setPriceConvertedProm(value);
                                        });
                                        ConvertedDeviseWithoutMoneySign(
                                            announce.devise,
                                            currency,
                                            totalPriceProm
                                        ).then((pricePromFinal: any): any => {
                                            setTotalPriceProm(pricePromFinal);
                                        });
                                        ConvertedDeviseWithoutMoneySign(
                                            announce.devise,
                                            currency,
                                            totalPriceNorm
                                        ).then((priceNormFinal: any): any => {
                                            setTotalPriceSimple(
                                                Number(priceNormFinal)
                                            );
                                        });
                                        ConvertedDeviseWithoutMoneySign(
                                            transaction.reservation.announce
                                                .devise,
                                            currency,
                                            Number(
                                                announceCleaningFees.toFixed(2)
                                            )
                                        )
                                            .then((value: any): any =>
                                                setCleaningFees(value)
                                            )
                                            .catch((error) =>
                                                console.log(error)
                                            );
                                        if (totalService > 0) {
                                            ConvertedDeviseWithoutMoneySign(
                                                "XAF",
                                                currency,
                                                Number(totalService.toFixed(2))
                                            )
                                                .then(
                                                    (
                                                        totalServiceConverted: any
                                                    ): any => {
                                                        ConvertedDeviseWithoutMoneySign(
                                                            announce.devise,
                                                            currency,
                                                            Number(
                                                                priceWithDaysWithCleanningAndCmomission.toFixed(
                                                                    2
                                                                )
                                                            )
                                                        )
                                                            .then(
                                                                (
                                                                    bookingPrice: any
                                                                ): any => {
                                                                    setPriceBookingconverted(
                                                                        Number(
                                                                            bookingPrice
                                                                        )
                                                                    );
                                                                    setPriceServiceconverted(
                                                                        Number(
                                                                            totalServiceConverted
                                                                        )
                                                                    );
                                                                    setPriceConvertedFinal(
                                                                        Number(
                                                                            bookingPrice
                                                                        ) +
                                                                            Number(
                                                                                totalServiceConverted
                                                                            )
                                                                    );
                                                                }
                                                            )
                                                            .catch((error) =>
                                                                console.log(
                                                                    error
                                                                )
                                                            );
                                                    }
                                                )
                                                .catch((error) =>
                                                    console.log(error)
                                                );
                                        } else {
                                            ConvertedDeviseWithoutMoneySign(
                                                announce.devise,
                                                currency,
                                                Number(
                                                    priceWithDaysWithCleanningAndCmomission.toFixed(
                                                        2
                                                    )
                                                )
                                            )
                                                .then(
                                                    (
                                                        bookingPrice: any
                                                    ): any => {
                                                        setPriceBookingconverted(
                                                            Number(bookingPrice)
                                                        );
                                                        setPriceConvertedFinal(
                                                            Number(bookingPrice)
                                                        );
                                                    }
                                                )
                                                .catch((error) =>
                                                    console.log(error)
                                                );
                                        }
                                        ConvertedDeviseWithoutMoneySign(
                                            (!transaction.amountCredit || transaction.amountCredit === 0) ? announce.devise : 'XAF',
                                            currency,
                                            Number(
                                                transaction.amount.toFixed(2)
                                            )
                                        )
                                            .then((bookingPrice: any): any => {
                                                setPriceConvertedFinalFromTransaction(
                                                    Number(bookingPrice)
                                                );
                                            })
                                            .catch((error) =>
                                                console.log(error)
                                            );
                                        ConvertedDeviseWithoutMoneySign(
                                            'XAF',
                                            currency,
                                            Number(
                                                transaction.amountCredit.toFixed(2)
                                            )
                                        )
                                            .then((creditPrice: any): any => {
                                                setPriceCreditFromTransaction(
                                                    Number(creditPrice)
                                                );
                                            })
                                            .catch((error) =>
                                                console.log(error)
                                            );
                                    } else {
                                        const jours = getDayNumber(
                                            transaction.reservation.dateCheckIn,
                                            transaction.reservation.dateCheckOut
                                        );
                                        let priceNormal;
                                        if (
                                            jours >= 7 &&
                                            jours < 14 &&
                                            reservation.announce.priceWeekly &&
                                            reservation.announce.priceWeekly > 0
                                        ) {
                                            priceNormal = Number(
                                                reservation.detailAnnouce
                                                    ? (
                                                          reservation
                                                              .detailAnnouce
                                                              .priceWeekly /
                                                              7 +
                                                          (reservation
                                                              .detailAnnouce
                                                              .priceWeekly /
                                                              7) *
                                                              (percentage / 100)
                                                      ).toFixed(2)
                                                    : (
                                                          reservation.announce
                                                              .priceWeekly /
                                                              7 +
                                                          (reservation.announce
                                                              .priceWeekly /
                                                              7) *
                                                              (percentage / 100)
                                                      ).toFixed(2)
                                            );
                                            setTarif(ETarifs.HEBDOMADAIRE);
                                        } else if (
                                            jours >= 14 &&
                                            jours < 30 &&
                                            reservation.announce
                                                .priceBiWeekly &&
                                            reservation.announce.priceBiWeekly >
                                                0
                                        ) {
                                            priceNormal = Number(
                                                reservation.detailAnnouce
                                                    ? (
                                                          reservation
                                                              .detailAnnouce
                                                              .priceBiWeekly /
                                                              14 +
                                                          (reservation
                                                              .detailAnnouce
                                                              .priceBiWeekly /
                                                              14) *
                                                              (percentage / 100)
                                                      ).toFixed(2)
                                                    : (
                                                          reservation.announce
                                                              .priceBiWeekly /
                                                              14 +
                                                          (reservation.announce
                                                              .priceBiWeekly /
                                                              14) *
                                                              (percentage / 100)
                                                      ).toFixed(2)
                                            );
                                            setTarif(ETarifs.QUINZAINE);
                                        } else if (
                                            jours >= 30 &&
                                            reservation.announce.priceMonthly &&
                                            reservation.announce.priceMonthly >
                                                0
                                        ) {
                                            priceNormal = Number(
                                                reservation.detailAnnouce
                                                    ? (
                                                          reservation
                                                              .detailAnnouce
                                                              .priceMonthly /
                                                              30 +
                                                          (reservation
                                                              .detailAnnouce
                                                              .priceMonthly /
                                                              30) *
                                                              (percentage / 100)
                                                      ).toFixed(2)
                                                    : (
                                                          reservation.announce
                                                              .priceMonthly /
                                                              30 +
                                                          (reservation.announce
                                                              .priceMonthly /
                                                              30) *
                                                              (percentage / 100)
                                                      ).toFixed(2)
                                            );
                                            setTarif(ETarifs.MENSUEL);
                                        } else {
                                            // console.log("ato zao mande",reservation.detailAnnouce)
                                            priceNormal = Number(
                                                (reservation.detailAnnouce
                                                    ? reservation.detailAnnouce
                                                          .price +
                                                      reservation.detailAnnouce
                                                          .price *
                                                          (percentage / 100)
                                                    : reservation.announce
                                                          .price +
                                                      reservation.announce
                                                          .price *
                                                          (percentage / 100)
                                                ).toFixed(2)
                                            );
                                            setTarif(ETarifs.JOURNALIER);
                                        }
                                        const priceWithDays =
                                            priceNormal * jours;
                                        priceWithDaysWithCleanningAndCmomission =
                                            reservation.detailAnnouce
                                                ? priceWithDays +
                                                  (reservation.detailAnnouce
                                                      .cleaningFees +
                                                      reservation.detailAnnouce
                                                          .cleaningFees *
                                                          (percentage / 100))
                                                : priceWithDays +
                                                  (transaction.reservation
                                                      .announce.cleaningFees +
                                                      transaction.reservation
                                                          .announce
                                                          .cleaningFees *
                                                          (percentage / 100));
                                        const totalService =
                                            transaction.reservation.services
                                                .length > 0
                                                ? transaction.reservation.services.reduce(
                                                      (
                                                          prev: any,
                                                          service: any
                                                      ) => prev + service.price,
                                                      0
                                                  )
                                                : 0;
                                        announceCleaningFees =
                                            reservation.detailAnnouce
                                                ? reservation.detailAnnouce
                                                      .cleaningFees +
                                                  reservation.detailAnnouce
                                                      .cleaningFees *
                                                      (percentage / 100)
                                                : announce.cleaningFees +
                                                  announce.cleaningFees *
                                                      (percentage / 100);

                                        ConvertedDeviseWithMoneySign(
                                            transaction.reservation.announce
                                                .devise,
                                            currency,
                                            priceNormal
                                        )
                                            .then((value: any): any =>
                                                setPriceConverted(value)
                                            )
                                            .catch((error) =>
                                                console.log(error)
                                            );
                                        ConvertedDeviseWithoutMoneySign(
                                            transaction.reservation.announce
                                                .devise,
                                            currency,
                                            Number(
                                                announceCleaningFees.toFixed(2)
                                            )
                                        )
                                            .then((value: any): any =>
                                                setCleaningFees(value)
                                            )
                                            .catch((error) =>
                                                console.log(error)
                                            );
                                        ConvertedDeviseWithoutMoneySign(
                                            transaction.reservation.announce
                                                .devise,
                                            currency,
                                            Number(priceWithDays.toFixed(2))
                                        )
                                            .then((value: any): any =>
                                                setPriceWithoutCleaningFees(
                                                    value
                                                )
                                            )
                                            .catch((error) =>
                                                console.log(error)
                                            );

                                        if (totalService > 0) {
                                            ConvertedDeviseWithoutMoneySign(
                                                "XAF",
                                                currency,
                                                Number(totalService.toFixed(2))
                                            )
                                                .then(
                                                    (
                                                        totalServiceConverted: any
                                                    ): any => {
                                                        ConvertedDeviseWithoutMoneySign(
                                                            transaction
                                                                .reservation
                                                                .announce
                                                                .devise,
                                                            currency,
                                                            Number(
                                                                priceWithDaysWithCleanningAndCmomission.toFixed(
                                                                    2
                                                                )
                                                            )
                                                        )
                                                            .then(
                                                                (
                                                                    bookingPrice: any
                                                                ): any => {
                                                                    setPriceBookingconverted(
                                                                        Number(
                                                                            bookingPrice
                                                                        )
                                                                    );
                                                                    setPriceServiceconverted(
                                                                        Number(
                                                                            totalServiceConverted
                                                                        )
                                                                    );
                                                                    setPriceConvertedFinal(
                                                                        Number(
                                                                            bookingPrice
                                                                        ) +
                                                                            Number(
                                                                                totalServiceConverted
                                                                            )
                                                                    );
                                                                }
                                                            )
                                                            .catch((error) =>
                                                                console.log(
                                                                    error
                                                                )
                                                            );
                                                    }
                                                )
                                                .catch((error) =>
                                                    console.log(error)
                                                );
                                        } else {
                                            ConvertedDeviseWithoutMoneySign(
                                                transaction.reservation.announce
                                                    .devise,
                                                currency,
                                                Number(
                                                    priceWithDaysWithCleanningAndCmomission.toFixed(
                                                        2
                                                    )
                                                )
                                            )
                                                .then(
                                                    (
                                                        bookingPrice: any
                                                    ): any => {
                                                        setPriceBookingconverted(
                                                            Number(bookingPrice)
                                                        );
                                                        setPriceConvertedFinal(
                                                            Number(bookingPrice)
                                                        );
                                                    }
                                                )
                                                .catch((error) =>
                                                    console.log(error)
                                                );
                                        }
                                        ConvertedDeviseWithoutMoneySign(
                                            (!transaction.amountCredit || transaction.amountCredit === 0) ? announce.devise : 'XAF',
                                            currency,
                                            Number(
                                                transaction.amount.toFixed(2)
                                            )
                                        )
                                            .then((bookingPrice: any): any => {
                                                setPriceConvertedFinalFromTransaction(
                                                    Number(bookingPrice)
                                                );
                                            })
                                            .catch((error) =>
                                                console.log(error)
                                            );
                                            ConvertedDeviseWithoutMoneySign(
                                                'XAF',
                                                currency,
                                                Number(
                                                    transaction.amountCredit.toFixed(2)
                                                )
                                            )
                                                .then((creditPrice: any): any => {
                                                    setPriceCreditFromTransaction(
                                                        Number(creditPrice)
                                                    );
                                                })
                                                .catch((error) =>
                                                    console.log(error)
                                                );
                                    }

                                    /* en cas d'anulation*/

                                    if (
                                        reservation.canceled ||
                                        reservation.status[
                                            reservation.status.length - 1
                                        ].status === EStatus.CANCELLED ||
                                        reservation.status[
                                            reservation.status.length - 1
                                        ].status ===
                                            EStatus.CANCELLED_BY_ADMIN ||
                                        reservation.status[
                                            reservation.status.length - 1
                                        ].status === EStatus.REJECTED
                                    ) {
                                        if (
                                            getRefundTypeFact(
                                                new Date(
                                                    transaction.reservation.dateCheckIn
                                                ),
                                                transaction.reservation.announce
                                                    .freeRefundDay,
                                                reservation.status[
                                                    reservation.status.length -
                                                        1
                                                ].date
                                            ) === ERefundType.PreStay &&
                                            reservation.status?.some(
                                                (status: any) =>
                                                    status.status ===
                                                    EStatus.APPROVED
                                            )
                                        ) {
                                            const daysPassedAmount =
                                                _bookingPrice *
                                                getPrestayPassedNumberFact(
                                                    new Date(
                                                        reservation.dateCheckIn
                                                    ),
                                                    reservation.announce
                                                        .freeRefundDay,
                                                    reservation.status[
                                                        reservation.status
                                                            .length - 1
                                                    ].date
                                                );
                                            const penaltyFeesAmount =
                                                reservation.announce
                                                    .penaltyDayFeesAfterBookingStarted *
                                                _bookingPrice;
                                            const travellerFeesAmount =
                                                daysPassedAmount +
                                                penaltyFeesAmount +
                                                announceCleaningFees;
                                            const travellerRefundInitial =
                                                priceWithDaysWithCleanningAndCmomission -
                                                    travellerFeesAmount >
                                                0
                                                    ? priceWithDaysWithCleanningAndCmomission -
                                                      travellerFeesAmount
                                                    : 0;
                                            const travellerReversalFees =
                                                (travellerRefundInitial *
                                                    travellerPaymentMethodFee) /
                                                100;
                                            const travellerValue =
                                                travellerRefundInitial -
                                                    travellerReversalFees >
                                                0
                                                    ? travellerRefundInitial -
                                                      travellerReversalFees
                                                    : 0;
                                            ConvertedDeviseWithoutMoneySign(
                                                reservation.announce.devise ||
                                                "XAF",
                                                currency,
                                                Number(
                                                    daysPassedAmount.toFixed(2)
                                                )
                                            )
                                                .then((value: any): any => {
                                                    setPassedDaysFees(value);
                                                })
                                                .catch((error) =>
                                                    console.log(error)
                                                );
                                            ConvertedDeviseWithoutMoneySign(
                                                reservation.announce.devise ||
                                                "XAF",
                                                currency,
                                                Number(
                                                    travellerRefundInitial.toFixed(
                                                        2
                                                    )
                                                )
                                            )
                                                .then((value: any): any => {
                                                    setTravellerInitialRefundValue(
                                                        value
                                                    );
                                                })
                                                .catch((error) =>
                                                    console.log(error)
                                                );
                                            ConvertedDeviseWithoutMoneySign(
                                                reservation.announce.devise ||
                                                "XAF",
                                                currency,
                                                Number(
                                                    penaltyFeesAmount.toFixed(2)
                                                )
                                            )
                                                .then((value: any): any => {
                                                    setPenaltyDaysFees(value);
                                                })
                                                .catch((error) =>
                                                    console.log(error)
                                                );
                                            ConvertedDeviseWithoutMoneySign(
                                                reservation.announce.devise ||
                                                "XAF",
                                                currency,
                                                Number(
                                                    travellerFeesAmount.toFixed(
                                                        2
                                                    )
                                                )
                                            )
                                                .then((value: any): any => {
                                                    setTravellerAmount(value);
                                                })
                                                .catch((error) =>
                                                    console.log(error)
                                                );
                                            ConvertedDeviseWithoutMoneySign(
                                                reservation.announce.devise ||
                                                "XAF",
                                                currency,
                                                Number(
                                                    travellerReversalFees.toFixed(
                                                        2
                                                    )
                                                )
                                            )
                                                .then((value: any): any => {
                                                    setReversalFeesAmount(
                                                        value
                                                    );
                                                })
                                                .catch((error) =>
                                                    console.log(error)
                                                );
                                            ConvertedDeviseWithoutMoneySign(
                                                reservation.announce.devise ||
                                                "XAF",
                                                currency,
                                                Number(
                                                    travellerValue.toFixed(2)
                                                )
                                            )
                                                .then((value: any): any => {
                                                    setTravellerRefundFinal(
                                                        value
                                                    );
                                                    if (
                                                        travellerPaymentMethod ===
                                                        EPaymentMethod.Paypal
                                                    ) {
                                                        setRefundTraveller({
                                                            ...refundTraveller,
                                                            amount: {
                                                                value: value,
                                                                currency:
                                                                    currency,
                                                            },
                                                            reservation:
                                                                reservation._id ||
                                                                "",
                                                            recepient_type:
                                                                "EMAIL",
                                                            receiver:
                                                                travellerPaymentAccount !==
                                                                ""
                                                                    ? travellerPaymentAccount
                                                                    : "",
                                                        });
                                                    } else {
                                                        setRefundTravellerDohone(
                                                            {
                                                                ...refundTravellerDohone,
                                                                destination:
                                                                    travellerPaymentAccount !==
                                                                    ""
                                                                        ? travellerPaymentAccount
                                                                        : "",
                                                                mode: EPaymentMethod.Orange
                                                                    ? DohonePayoutMode.orangeMoney
                                                                    : EPaymentMethod.MTN
                                                                    ? DohonePayoutMode.mtnMobileMoney
                                                                    : DohonePayoutMode.expressUnion,
                                                                amount: value,
                                                                devise: currency,
                                                                nameDest:
                                                                    reservation
                                                                        .traveller
                                                                        .firstName,
                                                                ville: reservation
                                                                    .announce
                                                                    .property
                                                                    .address
                                                                    .city.name,
                                                                pays: reservation
                                                                    .announce
                                                                    .property
                                                                    .address
                                                                    .country.name,
                                                                rUserId:
                                                                    reservation
                                                                        .traveller
                                                                        ._id,
                                                                reservation:
                                                                    reservation._id ||
                                                                    "",
                                                            }
                                                        );
                                                    }
                                                })
                                                .catch((error) =>
                                                    console.log(error)
                                                );
                                        } else if (
                                            getRefundTypeFact(
                                                new Date(
                                                    transaction.reservation.dateCheckIn
                                                ),
                                                transaction.reservation.announce
                                                    .freeRefundDay,
                                                reservation.status[
                                                    reservation.status.length -
                                                        1
                                                ].date
                                            ) === ERefundType.Paid &&
                                            reservation.status?.some(
                                                (status: any) =>
                                                    status.status ===
                                                    EStatus.APPROVED
                                            )
                                        ) {
                                            const penaltyFeesAmount =
                                                reservation.announce
                                                    .penaltyDayFees *
                                                _bookingPrice;
                                            const travellerRefundInitial =
                                                priceWithDaysWithCleanningAndCmomission -
                                                    penaltyFeesAmount >
                                                0
                                                    ? priceWithDaysWithCleanningAndCmomission -
                                                      penaltyFeesAmount
                                                    : 0;
                                            const travellerReversalFees =
                                                (travellerRefundInitial *
                                                    travellerPaymentMethodFee) /
                                                100;
                                            const travellerValue =
                                                travellerRefundInitial -
                                                    travellerReversalFees >
                                                0
                                                    ? travellerRefundInitial -
                                                      travellerReversalFees
                                                    : 0;
                                            ConvertedDeviseWithoutMoneySign(
                                                reservation.announce.devise ||
                                                "XAF",
                                                currency,
                                                Number(
                                                    penaltyFeesAmount.toFixed(2)
                                                )
                                            )
                                                .then((value: any): any => {
                                                    setPenaltyDaysFees(value);
                                                })
                                                .catch((error) =>
                                                    console.log(error)
                                                );
                                            ConvertedDeviseWithoutMoneySign(
                                                reservation.announce.devise ||
                                                "XAF",
                                                currency,
                                                Number(
                                                    travellerRefundInitial.toFixed(
                                                        2
                                                    )
                                                )
                                            )
                                                .then((value: any): any => {
                                                    setTravellerInitialRefundValue(
                                                        value
                                                    );
                                                })
                                                .catch((error) =>
                                                    console.log(error)
                                                );
                                            ConvertedDeviseWithoutMoneySign(
                                                reservation.announce.devise ||
                                                "XAF",
                                                currency,
                                                Number(
                                                    travellerReversalFees.toFixed(
                                                        2
                                                    )
                                                )
                                            )
                                                .then((value: any): any => {
                                                    setReversalFeesAmount(
                                                        value
                                                    );
                                                })
                                                .catch((error) =>
                                                    console.log(error)
                                                );
                                            ConvertedDeviseWithoutMoneySign(
                                                reservation.announce.devise ||
                                                "XAF",
                                                currency,
                                                Number(
                                                    penaltyFeesAmount.toFixed(2)
                                                )
                                            )
                                                .then((value: any): any => {
                                                    setTravellerAmount(value);
                                                })
                                                .catch((error) =>
                                                    console.log(error)
                                                );
                                            ConvertedDeviseWithoutMoneySign(
                                                reservation.announce.devise ||
                                                "XAF",
                                                currency,
                                                Number(
                                                    travellerValue.toFixed(2)
                                                )
                                            )
                                                .then((value: any): any => {
                                                    setTravellerRefundFinal(
                                                        value
                                                    );
                                                    if (
                                                        travellerPaymentMethod ===
                                                        EPaymentMethod.Paypal
                                                    ) {
                                                        setRefundTraveller({
                                                            ...refundTraveller,
                                                            amount: {
                                                                value: value,
                                                                currency:
                                                                    currency,
                                                            },
                                                            reservation:
                                                                reservation._id ||
                                                                "",
                                                            recepient_type:
                                                                "EMAIL",
                                                            receiver:
                                                                travellerPaymentAccount !==
                                                                ""
                                                                    ? travellerPaymentAccount
                                                                    : "",
                                                        });
                                                    } else {
                                                        setRefundTravellerDohone(
                                                            {
                                                                ...refundTravellerDohone,
                                                                destination:
                                                                    travellerPaymentAccount !==
                                                                    ""
                                                                        ? travellerPaymentAccount
                                                                        : "",
                                                                mode: EPaymentMethod.Orange
                                                                    ? DohonePayoutMode.orangeMoney
                                                                    : EPaymentMethod.MTN
                                                                    ? DohonePayoutMode.mtnMobileMoney
                                                                    : DohonePayoutMode.expressUnion,
                                                                amount: value,
                                                                devise: currency,
                                                                nameDest:
                                                                    reservation
                                                                        .traveller
                                                                        .firstName,
                                                                ville: reservation
                                                                    .announce
                                                                    .property
                                                                    .address
                                                                    .city.name,
                                                                pays: reservation
                                                                    .announce
                                                                    .property
                                                                    .address
                                                                    .country.name,
                                                                rUserId:
                                                                    reservation
                                                                        .traveller
                                                                        ._id,
                                                                reservation:
                                                                    reservation._id ||
                                                                    "",
                                                            }
                                                        );
                                                    }
                                                })
                                                .catch((error) =>
                                                    console.log(error)
                                                );
                                        } else {
                                            //Gratuit
                                            const travellerRefundInitial =
                                                priceWithDaysWithCleanningAndCmomission;
                                            const travellerReversalFees =
                                                (travellerRefundInitial *
                                                    travellerPaymentMethodFee) /
                                                100;
                                            const travellerValue =
                                                travellerRefundInitial -
                                                    travellerReversalFees >
                                                0
                                                    ? travellerRefundInitial -
                                                      travellerReversalFees
                                                    : 0;
                                            ConvertedDeviseWithoutMoneySign(
                                                reservation.announce.devise ||
                                                "XAF",
                                                currency,
                                                Number(
                                                    travellerRefundInitial.toFixed(
                                                        2
                                                    )
                                                )
                                            )
                                                .then((value: any): any => {
                                                    setTravellerInitialRefundValue(
                                                        value
                                                    );
                                                })
                                                .catch((error) =>
                                                    console.log(error)
                                                );
                                            ConvertedDeviseWithoutMoneySign(
                                                reservation.announce.devise ||
                                                "XAF",
                                                currency,
                                                Number(
                                                    travellerReversalFees.toFixed(
                                                        2
                                                    )
                                                )
                                            )
                                                .then((value: any): any => {
                                                    setReversalFeesAmount(
                                                        value
                                                    );
                                                })
                                                .catch((error) =>
                                                    console.log(error)
                                                );
                                            ConvertedDeviseWithoutMoneySign(
                                                reservation.announce.devise ||
                                                    "XAF",
                                                currency,
                                                Number(
                                                    travellerValue.toFixed(2)
                                                )
                                            )
                                                .then((value: any): any => {
                                                    setTravellerRefundFinal(
                                                        value
                                                    );
                                                    if (
                                                        travellerPaymentMethod ===
                                                        EPaymentMethod.Paypal
                                                    ) {
                                                        setRefundTraveller({
                                                            ...refundTraveller,
                                                            amount: {
                                                                value: value,
                                                                currency:
                                                                    currency,
                                                            },
                                                            reservation:
                                                                reservation._id ||
                                                                "",
                                                            recepient_type:
                                                                "EMAIL",
                                                            receiver:
                                                                travellerPaymentAccount !==
                                                                ""
                                                                    ? travellerPaymentAccount
                                                                    : "",
                                                        });
                                                    } else {
                                                        setRefundTravellerDohone(
                                                            {
                                                                ...refundTravellerDohone,
                                                                destination:
                                                                    travellerPaymentAccount !==
                                                                    ""
                                                                        ? travellerPaymentAccount
                                                                        : "",
                                                                mode: EPaymentMethod.Orange
                                                                    ? DohonePayoutMode.orangeMoney
                                                                    : EPaymentMethod.MTN
                                                                    ? DohonePayoutMode.mtnMobileMoney
                                                                    : DohonePayoutMode.expressUnion,
                                                                amount: value,
                                                                devise: currency,
                                                                nameDest:
                                                                    reservation
                                                                        .traveller
                                                                        .firstName,
                                                                ville: reservation
                                                                    .announce
                                                                    .property
                                                                    .address
                                                                    .city.name,
                                                                pays: reservation
                                                                    .announce
                                                                    .property
                                                                    .address
                                                                    .country.name,
                                                                rUserId:
                                                                    reservation
                                                                        .traveller
                                                                        ._id,
                                                                reservation:
                                                                    reservation._id ||
                                                                    "",
                                                            }
                                                        );
                                                    }
                                                })
                                                .catch((error) =>
                                                    console.log(error)
                                                );
                                        }
                                    }
                                }
                            })
                            .catch((error) => {
                                setLoadingPage(false);
                                console.log("Get commission fee error", error);
                            });
                    } else {
                        confirmServ
                            .getCommissionFeeByCountryAndCityId(
                                transaction.reservation.announce?.property
                                    ?.address?.country?.name,
                                transaction.reservation.announce?.property
                                    ?.address?.city?.name
                            )
                            .then((respCom) => {
                                /*console.log("ReceiptReservation.tsx - confirmServ.getCommissionFeeByCountryAndCityId arguments:", {
                                    countryName: transaction.reservation.announce?.property?.address?.country,
                                    cityName: transaction.reservation.announce?.property?.address?.city,
                                    countryId: transaction.reservation.announce?.property?.address?.country._id,
                                    cityNameId: transaction.reservation.announce?.property?.address?.city._id,
                                });*/
                                if (respCom.success) {
                                    const percentage = respCom.data
                                        ? respCom.data.percentage
                                        : 0;
                                    setCommissionFee(percentage);
                                    let priceProm;
                                    let priceNorm;
                                    let totalPriceProm;
                                    let totalPriceNorm;
                                    let priceWithDaysWithCleanningAndCmomission: number;
                                    let announceCleaningFees: number;
                                    let _bookingPrice = Number(
                                        (reservation.detailAnnouce
                                            ? reservation.detailAnnouce.price +
                                              reservation.detailAnnouce.price *
                                                  (percentage / 100)
                                            : reservation.announce.price +
                                              reservation.announce.price *
                                                  (percentage / 100)
                                        ).toFixed(2)
                                    );
                                    if (promotion) {
                                        priceProm = Number(
                                            (
                                                promotion.price +
                                                promotion.price *
                                                    (percentage / 100)
                                            ).toFixed(2)
                                        );

                                        if (
                                            nbJour >= 7 &&
                                            nbJour < 14 &&
                                            reservation.announce.priceWeekly &&
                                            reservation.announce.priceWeekly > 0
                                        ) {
                                            priceNorm = Number(
                                                reservation.detailAnnouce
                                                    ? (
                                                          reservation
                                                              .detailAnnouce
                                                              .priceWeekly /
                                                              7 +
                                                          (reservation
                                                              .detailAnnouce
                                                              .priceWeekly /
                                                              7) *
                                                              (percentage / 100)
                                                      ).toFixed(2)
                                                    : (
                                                          reservation.announce
                                                              .priceWeekly /
                                                              7 +
                                                          (reservation.announce
                                                              .priceWeekly /
                                                              7) *
                                                              (percentage / 100)
                                                      ).toFixed(2)
                                            );
                                            setTarif(ETarifs.HEBDOMADAIRE);
                                        } else if (
                                            nbJour >= 14 &&
                                            nbJour < 30 &&
                                            reservation.announce
                                                .priceBiWeekly &&
                                            reservation.announce.priceBiWeekly >
                                                0
                                        ) {
                                            priceNorm = Number(
                                                reservation.detailAnnouce
                                                    ? (
                                                          reservation
                                                              .detailAnnouce
                                                              .priceBiWeekly /
                                                              14 +
                                                          (reservation
                                                              .detailAnnouce
                                                              .priceBiWeekly /
                                                              14) *
                                                              (percentage / 100)
                                                      ).toFixed(2)
                                                    : (
                                                          reservation.announce
                                                              .priceBiWeekly /
                                                              14 +
                                                          (reservation.announce
                                                              .priceBiWeekly /
                                                              14) *
                                                              (percentage / 100)
                                                      ).toFixed(2)
                                            );
                                            setTarif(ETarifs.QUINZAINE);
                                        } else if (
                                            nbJour >= 30 &&
                                            reservation.announce.priceMonthly &&
                                            reservation.announce.priceMonthly >
                                                0
                                        ) {
                                            priceNorm = Number(
                                                reservation.detailAnnouce
                                                    ? (
                                                          reservation
                                                              .detailAnnouce
                                                              .priceMonthly /
                                                              30 +
                                                          (reservation
                                                              .detailAnnouce
                                                              .priceMonthly /
                                                              30) *
                                                              (percentage / 100)
                                                      ).toFixed(2)
                                                    : (
                                                          reservation.announce
                                                              .priceMonthly /
                                                              30 +
                                                          (reservation.announce
                                                              .priceMonthly /
                                                              30) *
                                                              (percentage / 100)
                                                      ).toFixed(2)
                                            );
                                            setTarif(ETarifs.MENSUEL);
                                        } else {
                                            priceNorm = Number(
                                                (reservation.detailAnnouce
                                                    ? reservation.detailAnnouce
                                                          .price +
                                                      reservation.detailAnnouce
                                                          .price *
                                                          (percentage / 100)
                                                    : reservation.announce
                                                          .price +
                                                      reservation.announce
                                                          .price *
                                                          (percentage / 100)
                                                ).toFixed(2)
                                            );
                                            setTarif(ETarifs.JOURNALIER);
                                        }
                                        totalPriceProm =
                                            priceProm * nbjours_prom;
                                        totalPriceNorm =
                                            priceNorm * nbjours_simple;
                                        priceWithDaysWithCleanningAndCmomission =
                                            totalPriceNorm +
                                            totalPriceProm +
                                            (announce.cleaningFees +
                                                announce.cleaningFees *
                                                    (percentage / 100));
                                        const totalService =
                                            transaction.reservation.services
                                                .length > 0
                                                ? transaction.reservation.services.reduce(
                                                      (
                                                          prev: any,
                                                          service: any
                                                      ) => prev + service.price,
                                                      0
                                                  )
                                                : 0;
                                        announceCleaningFees =
                                            announce.cleaningFees +
                                            announce.cleaningFees *
                                                (percentage / 100);
                                        ConvertedDeviseWithMoneySign(
                                            announce.devise,
                                            currency,
                                            priceNorm
                                        )
                                            .then((value: any): any => {
                                                setPriceConverted(value);
                                            })
                                            .catch((error) =>
                                                console.log(error)
                                            );
                                        ConvertedDeviseWithMoneySign(
                                            announce.devise,
                                            currency,
                                            priceProm
                                        ).then((value: any): any => {
                                            setPriceConvertedProm(value);
                                        });
                                        ConvertedDeviseWithoutMoneySign(
                                            announce.devise,
                                            currency,
                                            totalPriceProm
                                        ).then((pricePromFinal: any): any => {
                                            setTotalPriceProm(pricePromFinal);
                                        });
                                        ConvertedDeviseWithoutMoneySign(
                                            announce.devise,
                                            currency,
                                            totalPriceNorm
                                        ).then((priceNormFinal: any): any => {
                                            setTotalPriceSimple(
                                                Number(priceNormFinal)
                                            );
                                        });
                                        ConvertedDeviseWithoutMoneySign(
                                            transaction.reservation.announce
                                                .devise,
                                            currency,
                                            Number(
                                                announceCleaningFees.toFixed(2)
                                            )
                                        )
                                            .then((value: any): any =>
                                                setCleaningFees(value)
                                            )
                                            .catch((error) =>
                                                console.log(error)
                                            );
                                        if (totalService > 0) {
                                            ConvertedDeviseWithoutMoneySign(
                                                "XAF",
                                                currency,
                                                Number(totalService.toFixed(2))
                                            )
                                                .then(
                                                    (
                                                        totalServiceConverted: any
                                                    ): any => {
                                                        ConvertedDeviseWithoutMoneySign(
                                                            announce.devise,
                                                            currency,
                                                            Number(
                                                                priceWithDaysWithCleanningAndCmomission.toFixed(
                                                                    2
                                                                )
                                                            )
                                                        )
                                                            .then(
                                                                (
                                                                    bookingPrice: any
                                                                ): any => {
                                                                    setPriceBookingconverted(
                                                                        Number(
                                                                            bookingPrice
                                                                        )
                                                                    );
                                                                    setPriceServiceconverted(
                                                                        Number(
                                                                            totalServiceConverted
                                                                        )
                                                                    );
                                                                    setPriceConvertedFinal(
                                                                        Number(
                                                                            bookingPrice
                                                                        ) +
                                                                            Number(
                                                                                totalServiceConverted
                                                                            )
                                                                    );
                                                                }
                                                            )
                                                            .catch((error) =>
                                                                console.log(
                                                                    error
                                                                )
                                                            );
                                                    }
                                                )
                                                .catch((error) =>
                                                    console.log(error)
                                                );
                                        } else {
                                            ConvertedDeviseWithoutMoneySign(
                                                announce.devise,
                                                currency,
                                                Number(
                                                    priceWithDaysWithCleanningAndCmomission.toFixed(
                                                        2
                                                    )
                                                )
                                            )
                                                .then(
                                                    (
                                                        bookingPrice: any
                                                    ): any => {
                                                        setPriceBookingconverted(
                                                            Number(bookingPrice)
                                                        );
                                                        setPriceConvertedFinal(
                                                            Number(bookingPrice)
                                                        );
                                                    }
                                                )
                                                .catch((error) =>
                                                    console.log(error)
                                                );
                                        }
                                        ConvertedDeviseWithoutMoneySign(
                                            (!transaction.amountCredit || transaction.amountCredit === 0) ? announce.devise : 'XAF',
                                            currency,
                                            Number(
                                                transaction.amount.toFixed(2)
                                            )
                                        )
                                            .then((bookingPrice: any): any => {
                                                setPriceConvertedFinalFromTransaction(
                                                    Number(bookingPrice)
                                                );
                                            })
                                            .catch((error) =>
                                                console.log(error)
                                            );
                                            ConvertedDeviseWithoutMoneySign(
                                                'XAF',
                                                currency,
                                                Number(
                                                    transaction.amountCredit.toFixed(2)
                                                )
                                            )
                                                .then((creditPrice: any): any => {
                                                    setPriceCreditFromTransaction(
                                                        Number(creditPrice)
                                                    );
                                                })
                                                .catch((error) =>
                                                    console.log(error)
                                                );
                                    } else {
                                        const jours = getDayNumber(
                                            transaction.reservation.dateCheckIn,
                                            transaction.reservation.dateCheckOut
                                        );
                                        let priceNormal;
                                        if (
                                            jours >= 7 &&
                                            jours < 14 &&
                                            reservation.announce.priceWeekly &&
                                            reservation.announce.priceWeekly > 0
                                        ) {
                                            priceNormal = Number(
                                                reservation.detailAnnouce
                                                    ? (
                                                          reservation
                                                              .detailAnnouce
                                                              .priceWeekly /
                                                              7 +
                                                          (reservation
                                                              .detailAnnouce
                                                              .priceWeekly /
                                                              7) *
                                                              (percentage / 100)
                                                      ).toFixed(2)
                                                    : (
                                                          reservation.announce
                                                              .priceWeekly /
                                                              7 +
                                                          (reservation.announce
                                                              .priceWeekly /
                                                              7) *
                                                              (percentage / 100)
                                                      ).toFixed(2)
                                            );
                                            setTarif(ETarifs.HEBDOMADAIRE);
                                        } else if (
                                            jours >= 14 &&
                                            jours < 30 &&
                                            reservation.announce
                                                .priceBiWeekly &&
                                            reservation.announce.priceBiWeekly >
                                                0
                                        ) {
                                            priceNormal = Number(
                                                reservation.detailAnnouce
                                                    ? (
                                                          reservation
                                                              .detailAnnouce
                                                              .priceBiWeekly /
                                                              14 +
                                                          (reservation
                                                              .detailAnnouce
                                                              .priceBiWeekly /
                                                              14) *
                                                              (percentage / 100)
                                                      ).toFixed(2)
                                                    : (
                                                          reservation.announce
                                                              .priceBiWeekly /
                                                              14 +
                                                          (reservation.announce
                                                              .priceBiWeekly /
                                                              14) *
                                                              (percentage / 100)
                                                      ).toFixed(2)
                                            );
                                            setTarif(ETarifs.QUINZAINE);
                                        } else if (
                                            jours >= 30 &&
                                            reservation.announce.priceMonthly &&
                                            reservation.announce.priceMonthly >
                                                0
                                        ) {
                                            priceNormal = Number(
                                                reservation.detailAnnouce
                                                    ? (
                                                          reservation
                                                              .detailAnnouce
                                                              .priceMonthly /
                                                              30 +
                                                          (reservation
                                                              .detailAnnouce
                                                              .priceMonthly /
                                                              30) *
                                                              (percentage / 100)
                                                      ).toFixed(2)
                                                    : (
                                                          reservation.announce
                                                              .priceMonthly /
                                                              30 +
                                                          (reservation.announce
                                                              .priceMonthly /
                                                              30) *
                                                              (percentage / 100)
                                                      ).toFixed(2)
                                            );
                                            setTarif(ETarifs.MENSUEL);
                                        } else {
                                            // console.log("ato zao mande",reservation.detailAnnouce)
                                            priceNormal = Number(
                                                (reservation.detailAnnouce
                                                    ? reservation.detailAnnouce
                                                          .price +
                                                      reservation.detailAnnouce
                                                          .price *
                                                          (percentage / 100)
                                                    : reservation.announce
                                                          .price +
                                                      reservation.announce
                                                          .price *
                                                          (percentage / 100)
                                                ).toFixed(2)
                                            );
                                            setTarif(ETarifs.JOURNALIER);
                                        }
                                        const priceWithDays =
                                            priceNormal * jours;
                                        priceWithDaysWithCleanningAndCmomission =
                                            reservation.detailAnnouce
                                                ? priceWithDays +
                                                  (reservation.detailAnnouce
                                                      .cleaningFees +
                                                      reservation.detailAnnouce
                                                          .cleaningFees *
                                                          (percentage / 100))
                                                : priceWithDays +
                                                  (transaction.reservation
                                                      .announce.cleaningFees +
                                                      transaction.reservation
                                                          .announce
                                                          .cleaningFees *
                                                          (percentage / 100));
                                        const totalService =
                                            transaction.reservation.services
                                                .length > 0
                                                ? transaction.reservation.services.reduce(
                                                      (
                                                          prev: any,
                                                          service: any
                                                      ) => prev + service.price,
                                                      0
                                                  )
                                                : 0;
                                        announceCleaningFees =
                                            reservation.detailAnnouce
                                                ? reservation.detailAnnouce
                                                      .cleaningFees +
                                                  reservation.detailAnnouce
                                                      .cleaningFees *
                                                      (percentage / 100)
                                                : announce.cleaningFees +
                                                  announce.cleaningFees *
                                                      (percentage / 100);

                                        ConvertedDeviseWithMoneySign(
                                            transaction.reservation.announce
                                                .devise,
                                            currency,
                                            priceNormal
                                        )
                                            .then((value: any): any =>
                                                setPriceConverted(value)
                                            )
                                            .catch((error) =>
                                                console.log(error)
                                            );
                                        ConvertedDeviseWithoutMoneySign(
                                            transaction.reservation.announce
                                                .devise,
                                            currency,
                                            Number(
                                                announceCleaningFees.toFixed(2)
                                            )
                                        )
                                            .then((value: any): any =>
                                                setCleaningFees(value)
                                            )
                                            .catch((error) =>
                                                console.log(error)
                                            );
                                        ConvertedDeviseWithoutMoneySign(
                                            transaction.reservation.announce
                                                .devise,
                                            currency,
                                            Number(priceWithDays.toFixed(2))
                                        )
                                            .then((value: any): any =>
                                                setPriceWithoutCleaningFees(
                                                    value
                                                )
                                            )
                                            .catch((error) =>
                                                console.log(error)
                                            );

                                        if (totalService > 0) {
                                            ConvertedDeviseWithoutMoneySign(
                                                "XAF",
                                                currency,
                                                Number(totalService.toFixed(2))
                                            )
                                                .then(
                                                    (
                                                        totalServiceConverted: any
                                                    ): any => {
                                                        ConvertedDeviseWithoutMoneySign(
                                                            transaction
                                                                .reservation
                                                                .announce
                                                                .devise,
                                                            currency,
                                                            Number(
                                                                priceWithDaysWithCleanningAndCmomission.toFixed(
                                                                    2
                                                                )
                                                            )
                                                        )
                                                            .then(
                                                                (
                                                                    bookingPrice: any
                                                                ): any => {
                                                                    setPriceBookingconverted(
                                                                        Number(
                                                                            bookingPrice
                                                                        )
                                                                    );
                                                                    setPriceServiceconverted(
                                                                        Number(
                                                                            totalServiceConverted
                                                                        )
                                                                    );
                                                                    setPriceConvertedFinal(
                                                                        Number(
                                                                            bookingPrice
                                                                        ) +
                                                                            Number(
                                                                                totalServiceConverted
                                                                            )
                                                                    );
                                                                }
                                                            )
                                                            .catch((error) =>
                                                                console.log(
                                                                    error
                                                                )
                                                            );
                                                    }
                                                )
                                                .catch((error) =>
                                                    console.log(error)
                                                );
                                        } else {
                                            ConvertedDeviseWithoutMoneySign(
                                                transaction.reservation.announce
                                                    .devise,
                                                currency,
                                                Number(
                                                    priceWithDaysWithCleanningAndCmomission.toFixed(
                                                        2
                                                    )
                                                )
                                            )
                                                .then(
                                                    (
                                                        bookingPrice: any
                                                    ): any => {
                                                        setPriceBookingconverted(
                                                            Number(bookingPrice)
                                                        );
                                                        setPriceConvertedFinal(
                                                            Number(bookingPrice)
                                                        );
                                                    }
                                                )
                                                .catch((error) =>
                                                    console.log(error)
                                                );
                                        }
                                        ConvertedDeviseWithoutMoneySign(
                                            (!transaction.amountCredit || transaction.amountCredit === 0) ? announce.devise : 'XAF',
                                            currency,
                                            Number(
                                                transaction.amount.toFixed(2)
                                            )
                                        )
                                        .then(async (bookingPrice: any): Promise<any> => {
                                            setPriceConvertedFinalFromTransaction(Number(bookingPrice));
                                        
                                            // Check if transaction and transaction.amountCredit are defined
                                            if (transaction && typeof transaction.amountCredit !== 'undefined') {
                                                try {
                                                    // Use await to wait for the Promise to resolve
                                                    const creditPrice = await ConvertedDeviseWithoutMoneySign(
                                                        'XAF',
                                                        currency,
                                                        Number(transaction.amountCredit.toFixed(2))
                                                    );
                                                    setPriceCreditFromTransaction(Number(creditPrice));
                                                } catch (error) {
                                                    console.error("Error converting credit price:", error);
                                                    // Optionally, set a default value or handle the error
                                                    setPriceCreditFromTransaction(0); // Example: setting a default value
                                                }
                                            } else {
                                                console.error("Transaction or transaction.amountCredit is undefined");
                                                // Optionally, set a default value or handle this case differently
                                                setPriceCreditFromTransaction(0); // Example: setting a default value
                                            }
                                        })
                                        .catch((error) => {
                                            console.error("Error in booking price processing:", error);
                                        });
                                    }

                                    /* en cas d'anulation*/

                                    if (
                                        reservation.canceled ||
                                        reservation.status[
                                            reservation.status.length - 1
                                        ].status === EStatus.CANCELLED ||
                                        reservation.status[
                                            reservation.status.length - 1
                                        ].status ===
                                            EStatus.CANCELLED_BY_ADMIN ||
                                        reservation.status[
                                            reservation.status.length - 1
                                        ].status === EStatus.REJECTED
                                    ) {
                                        if (
                                            getRefundTypeFact(
                                                new Date(
                                                    transaction.reservation.dateCheckIn
                                                ),
                                                transaction.reservation.announce
                                                    .freeRefundDay,
                                                reservation.status[
                                                    reservation.status.length -
                                                        1
                                                ].date
                                            ) === ERefundType.PreStay &&
                                            reservation.status?.some(
                                                (status: any) =>
                                                    status.status ===
                                                    EStatus.APPROVED
                                            )
                                        ) {
                                            const daysPassedAmount =
                                                _bookingPrice *
                                                getPrestayPassedNumberFact(
                                                    new Date(
                                                        reservation.dateCheckIn
                                                    ),
                                                    reservation.announce
                                                        .freeRefundDay,
                                                    reservation.status[
                                                        reservation.status
                                                            .length - 1
                                                    ].date
                                                );
                                            const penaltyFeesAmount =
                                                reservation.announce
                                                    .penaltyDayFeesAfterBookingStarted *
                                                _bookingPrice;
                                            const travellerFeesAmount =
                                                daysPassedAmount +
                                                penaltyFeesAmount +
                                                announceCleaningFees;
                                            const travellerRefundInitial =
                                                priceWithDaysWithCleanningAndCmomission -
                                                    travellerFeesAmount >
                                                0
                                                    ? priceWithDaysWithCleanningAndCmomission -
                                                      travellerFeesAmount
                                                    : 0;
                                            const travellerReversalFees =
                                                (travellerRefundInitial *
                                                    travellerPaymentMethodFee) /
                                                100;
                                            const travellerValue =
                                                travellerRefundInitial -
                                                    travellerReversalFees >
                                                0
                                                    ? travellerRefundInitial -
                                                      travellerReversalFees
                                                    : 0;
                                            ConvertedDeviseWithoutMoneySign(
                                                reservation.announce.devise ||
                                                    "XAF",
                                                currency,
                                                Number(
                                                    daysPassedAmount.toFixed(2)
                                                )
                                            )
                                                .then((value: any): any => {
                                                    setPassedDaysFees(value);
                                                })
                                                .catch((error) =>
                                                    console.log(error)
                                                );
                                            ConvertedDeviseWithoutMoneySign(
                                                reservation.announce.devise ||
                                                    "XAF",
                                                currency,
                                                Number(
                                                    travellerRefundInitial.toFixed(
                                                        2
                                                    )
                                                )
                                            )
                                                .then((value: any): any => {
                                                    setTravellerInitialRefundValue(
                                                        value
                                                    );
                                                })
                                                .catch((error) =>
                                                    console.log(error)
                                                );
                                            ConvertedDeviseWithoutMoneySign(
                                                reservation.announce.devise ||
                                                "XAF",
                                                currency,
                                                Number(
                                                    penaltyFeesAmount.toFixed(2)
                                                )
                                            )
                                                .then((value: any): any => {
                                                    setPenaltyDaysFees(value);
                                                })
                                                .catch((error) =>
                                                    console.log(error)
                                                );
                                            ConvertedDeviseWithoutMoneySign(
                                                reservation.announce.devise ||
                                                "XAF",
                                                currency,
                                                Number(
                                                    travellerFeesAmount.toFixed(
                                                        2
                                                    )
                                                )
                                            )
                                                .then((value: any): any => {
                                                    setTravellerAmount(value);
                                                })
                                                .catch((error) =>
                                                    console.log(error)
                                                );
                                            ConvertedDeviseWithoutMoneySign(
                                                reservation.announce.devise ||
                                                "XAF",
                                                currency,
                                                Number(
                                                    travellerReversalFees.toFixed(
                                                        2
                                                    )
                                                )
                                            )
                                                .then((value: any): any => {
                                                    setReversalFeesAmount(
                                                        value
                                                    );
                                                })
                                                .catch((error) =>
                                                    console.log(error)
                                                );
                                            ConvertedDeviseWithoutMoneySign(
                                                reservation.announce.devise ||
                                                "XAF",
                                                currency,
                                                Number(
                                                    travellerValue.toFixed(2)
                                                )
                                            )
                                                .then((value: any): any => {
                                                    setTravellerRefundFinal(
                                                        value
                                                    );
                                                    if (
                                                        travellerPaymentMethod ===
                                                        EPaymentMethod.Paypal
                                                    ) {
                                                        setRefundTraveller({
                                                            ...refundTraveller,
                                                            amount: {
                                                                value: value,
                                                                currency:
                                                                    currency,
                                                            },
                                                            reservation:
                                                                reservation._id ||
                                                                "",
                                                            recepient_type:
                                                                "EMAIL",
                                                            receiver:
                                                                travellerPaymentAccount !==
                                                                ""
                                                                    ? travellerPaymentAccount
                                                                    : "",
                                                        });
                                                    } else {
                                                        setRefundTravellerDohone(
                                                            {
                                                                ...refundTravellerDohone,
                                                                destination:
                                                                    travellerPaymentAccount !==
                                                                    ""
                                                                        ? travellerPaymentAccount
                                                                        : "",
                                                                mode: EPaymentMethod.Orange
                                                                    ? DohonePayoutMode.orangeMoney
                                                                    : EPaymentMethod.MTN
                                                                    ? DohonePayoutMode.mtnMobileMoney
                                                                    : DohonePayoutMode.expressUnion,
                                                                amount: value,
                                                                devise: currency,
                                                                nameDest:
                                                                    reservation
                                                                        .traveller
                                                                        .firstName,
                                                                ville: reservation
                                                                    .announce
                                                                    .property
                                                                    .address
                                                                    .city.name,
                                                                pays: reservation
                                                                    .announce
                                                                    .property
                                                                    .address
                                                                    .country.name,
                                                                rUserId:
                                                                    reservation
                                                                        .traveller
                                                                        ._id,
                                                                reservation:
                                                                    reservation._id ||
                                                                    "",
                                                            }
                                                        );
                                                    }
                                                })
                                                .catch((error) =>
                                                    console.log(error)
                                                );
                                        } else if (
                                            getRefundTypeFact(
                                                new Date(
                                                    transaction.reservation.dateCheckIn
                                                ),
                                                transaction.reservation.announce
                                                    .freeRefundDay,
                                                reservation.status[
                                                    reservation.status.length -
                                                        1
                                                ].date
                                            ) === ERefundType.Paid &&
                                            reservation.status?.some(
                                                (status: any) =>
                                                    status.status ===
                                                    EStatus.APPROVED
                                            )
                                        ) {
                                            const penaltyFeesAmount =
                                                reservation.announce
                                                    .penaltyDayFees *
                                                _bookingPrice;
                                            const travellerRefundInitial =
                                                priceWithDaysWithCleanningAndCmomission -
                                                    penaltyFeesAmount >
                                                0
                                                    ? priceWithDaysWithCleanningAndCmomission -
                                                      penaltyFeesAmount
                                                    : 0;
                                            const travellerReversalFees =
                                                (travellerRefundInitial *
                                                    travellerPaymentMethodFee) /
                                                100;
                                            const travellerValue =
                                                travellerRefundInitial -
                                                    travellerReversalFees >
                                                0
                                                    ? travellerRefundInitial -
                                                      travellerReversalFees
                                                    : 0;
                                            ConvertedDeviseWithoutMoneySign(
                                                reservation.announce.devise ||
                                                "XAF",
                                                currency,
                                                Number(
                                                    penaltyFeesAmount.toFixed(2)
                                                )
                                            )
                                                .then((value: any): any => {
                                                    setPenaltyDaysFees(value);
                                                })
                                                .catch((error) =>
                                                    console.log(error)
                                                );
                                            ConvertedDeviseWithoutMoneySign(
                                                reservation.announce.devise ||
                                                "XAF",
                                                currency,
                                                Number(
                                                    travellerRefundInitial.toFixed(
                                                        2
                                                    )
                                                )
                                            )
                                                .then((value: any): any => {
                                                    setTravellerInitialRefundValue(
                                                        value
                                                    );
                                                })
                                                .catch((error) =>
                                                    console.log(error)
                                                );
                                            ConvertedDeviseWithoutMoneySign(
                                                reservation.announce.devise ||
                                                "XAF",
                                                currency,
                                                Number(
                                                    travellerReversalFees.toFixed(
                                                        2
                                                    )
                                                )
                                            )
                                                .then((value: any): any => {
                                                    setReversalFeesAmount(
                                                        value
                                                    );
                                                })
                                                .catch((error) =>
                                                    console.log(error)
                                                );
                                            ConvertedDeviseWithoutMoneySign(
                                                reservation.announce.devise ||
                                                "XAF",
                                                currency,
                                                Number(
                                                    penaltyFeesAmount.toFixed(2)
                                                )
                                            )
                                                .then((value: any): any => {
                                                    setTravellerAmount(value);
                                                })
                                                .catch((error) =>
                                                    console.log(error)
                                                );
                                            ConvertedDeviseWithoutMoneySign(
                                                reservation.announce.devise ||
                                                "XAF",
                                                currency,
                                                Number(
                                                    travellerValue.toFixed(2)
                                                )
                                            )
                                                .then((value: any): any => {
                                                    setTravellerRefundFinal(
                                                        value
                                                    );
                                                    if (
                                                        travellerPaymentMethod ===
                                                        EPaymentMethod.Paypal
                                                    ) {
                                                        setRefundTraveller({
                                                            ...refundTraveller,
                                                            amount: {
                                                                value: value,
                                                                currency:
                                                                    currency,
                                                            },
                                                            reservation:
                                                                reservation._id ||
                                                                "",
                                                            recepient_type:
                                                                "EMAIL",
                                                            receiver:
                                                                travellerPaymentAccount !==
                                                                ""
                                                                    ? travellerPaymentAccount
                                                                    : "",
                                                        });
                                                    } else {
                                                        setRefundTravellerDohone(
                                                            {
                                                                ...refundTravellerDohone,
                                                                destination:
                                                                    travellerPaymentAccount !==
                                                                    ""
                                                                        ? travellerPaymentAccount
                                                                        : "",
                                                                mode: EPaymentMethod.Orange
                                                                    ? DohonePayoutMode.orangeMoney
                                                                    : EPaymentMethod.MTN
                                                                    ? DohonePayoutMode.mtnMobileMoney
                                                                    : DohonePayoutMode.expressUnion,
                                                                amount: value,
                                                                devise: currency,
                                                                nameDest:
                                                                    reservation
                                                                        .traveller
                                                                        .firstName,
                                                                ville: reservation
                                                                    .announce
                                                                    .property
                                                                    .address
                                                                    .city.name,
                                                                pays: reservation
                                                                    .announce
                                                                    .property
                                                                    .address
                                                                    .country.name,
                                                                rUserId:
                                                                    reservation
                                                                        .traveller
                                                                        ._id,
                                                                reservation:
                                                                    reservation._id ||
                                                                    "",
                                                            }
                                                        );
                                                    }
                                                })
                                                .catch((error) =>
                                                    console.log(error)
                                                );
                                        } else {
                                            //Gratuit
                                            const travellerRefundInitial =
                                                priceWithDaysWithCleanningAndCmomission;
                                            const travellerReversalFees =
                                                (travellerRefundInitial *
                                                    travellerPaymentMethodFee) /
                                                100;
                                            const travellerValue =
                                                travellerRefundInitial -
                                                    travellerReversalFees >
                                                0
                                                    ? travellerRefundInitial -
                                                      travellerReversalFees
                                                    : 0;
                                            ConvertedDeviseWithoutMoneySign(
                                                reservation.announce.devise ||
                                                "XAF",
                                                currency,
                                                Number(
                                                    travellerRefundInitial.toFixed(
                                                        2
                                                    )
                                                )
                                            )
                                                .then((value: any): any => {
                                                    setTravellerInitialRefundValue(
                                                        value
                                                    );
                                                })
                                                .catch((error) =>
                                                    console.log(error)
                                                );
                                            ConvertedDeviseWithoutMoneySign(
                                                reservation.announce.devise ||
                                                "XAF",
                                                currency,
                                                Number(
                                                    travellerReversalFees.toFixed(
                                                        2
                                                    )
                                                )
                                            )
                                                .then((value: any): any => {
                                                    setReversalFeesAmount(
                                                        value
                                                    );
                                                })
                                                .catch((error) =>
                                                    console.log(error)
                                                );
                                            ConvertedDeviseWithoutMoneySign(
                                                reservation.announce.devise ||
                                                "XAF",
                                                currency,
                                                Number(
                                                    travellerValue.toFixed(2)
                                                )
                                            )
                                                .then((value: any): any => {
                                                    setTravellerRefundFinal(
                                                        value
                                                    );
                                                    if (
                                                        travellerPaymentMethod ===
                                                        EPaymentMethod.Paypal
                                                    ) {
                                                        setRefundTraveller({
                                                            ...refundTraveller,
                                                            amount: {
                                                                value: value,
                                                                currency:
                                                                    currency,
                                                            },
                                                            reservation:
                                                                reservation._id ||
                                                                "",
                                                            recepient_type:
                                                                "EMAIL",
                                                            receiver:
                                                                travellerPaymentAccount !==
                                                                ""
                                                                    ? travellerPaymentAccount
                                                                    : "",
                                                        });
                                                    } else {
                                                        setRefundTravellerDohone(
                                                            {
                                                                ...refundTravellerDohone,
                                                                destination:
                                                                    travellerPaymentAccount !==
                                                                    ""
                                                                        ? travellerPaymentAccount
                                                                        : "",
                                                                mode: EPaymentMethod.Orange
                                                                    ? DohonePayoutMode.orangeMoney
                                                                    : EPaymentMethod.MTN
                                                                    ? DohonePayoutMode.mtnMobileMoney
                                                                    : DohonePayoutMode.expressUnion,
                                                                amount: value,
                                                                devise: currency,
                                                                nameDest:
                                                                    reservation
                                                                        .traveller
                                                                        .firstName,
                                                                ville: reservation
                                                                    .announce
                                                                    .property
                                                                    .address
                                                                    .city.name,
                                                                pays: reservation
                                                                    .announce
                                                                    .property
                                                                    .address
                                                                    .country.name,
                                                                rUserId:
                                                                    reservation
                                                                        .traveller
                                                                        ._id,
                                                                reservation:
                                                                    reservation._id ||
                                                                    "",
                                                            }
                                                        );
                                                    }
                                                })
                                                .catch((error) =>
                                                    console.log(error)
                                                );
                                        }
                                    }
                                }
                            })
                            .catch((error) => {
                                setLoadingPage(false);
                                console.log("Get commission fee error", error);
                            });
                    }
                }

                setLoadingPage(false);
            })
            .catch((error) => {
                setLoadingPage(false);
                console.log("PaymentSuccess comp error", error);
            });
    }, [
        params,
        currency,
        travellerPaymentMethodFee,
        travellerPaymentMethod,
        refundTraveller,
        travellerPaymentAccount,
        refundTravellerDohone,
    ]);

    React.useEffect(() => {
        if (location.pathname.startsWith("/cancellation-receipt")) {
            setIsCancellation(true);
        }
    }, [location.pathname]);

    React.useEffect(() => {
        userReservService
            .getPaymentMethodFees(travellerPaymentMethod)
            .then((respMethodFee) => {
                if (respMethodFee.success) {
                    if (respMethodFee.data)
                        setTravellerPaymentMethodFee(
                            respMethodFee.data.percentage
                        );
                }
            });
    }, [travellerPaymentMethod, transaction]);

    function formatCurrency(amount: number, currency: any): string {
        const formatter = new Intl.NumberFormat(undefined, {
          style: 'currency',
          currency,
          minimumFractionDigits: currency === 'EUR' ? 2 : 0,
          maximumFractionDigits: currency === 'EUR' ? 2 : 0
        });
        return formatter.format(amount);
      }


    // Helper to check cancellation status
    function isCancellationStatus(statusArray?: Array<{ status: string }>): boolean {
        if (!statusArray || statusArray.length === 0) return false;
        const lastStatus = statusArray[statusArray.length - 1].status;
        return [EStatus.CANCELLED, EStatus.CANCELLED_BY_ADMIN, EStatus.REJECTED]
            .includes(lastStatus as EStatus);
    }

    // Reusable payment amount renderer
    function renderPaymentAmount() {
        return (transaction?.reservation?.canceled || isCancellationStatus(transaction?.reservation?.status)) && isCancellation ? (
            <Grid item>
                {formatCurrency(travellerRefundFinal, currency)}
            </Grid>
        ) : (
            <Grid item>
                {formatCurrency(priceConvertedFinalFromTransaction, currency)}
            </Grid>
        );
    }

    return (
        <>
            {loadingPage ? (
                <div className={classes.loading}>
                    <PropagateLoader color="#36D7B7" size={15} />
                </div>
            ) : (
                <div className={classes.container}>
                    <Stack direction="row" justifyContent="center">
                        <img
                            src={logo}
                            className={classes.logo}
                            alt="AfriqPnB Logo"
                        />
                    </Stack>
                    <Typography variant="h3" style={{ marginBottom: 24 }}>
                        {(transaction?.reservation?.canceled ||
                            transaction?.reservation?.status[
                                transaction?.reservation?.status.length - 1
                            ]?.status === EStatus.CANCELLED ||
                            transaction?.reservation?.status[
                                transaction?.reservation?.status.length - 1
                            ]?.status === EStatus.CANCELLED_BY_ADMIN ||
                            transaction?.reservation?.status[
                                transaction?.reservation?.status.length - 1
                            ]?.status === EStatus.REJECTED) &&
                        isCancellation
                            ? t("recu.labels.votre-recu-d-annulation")
                            : t("recu.labels.votre-recu-de-paiement")}
                    </Typography>
                    <ul className={classes.info} style={{ marginBottom: 24 }}>
                        <li>
                            <span>{t("recu.labels.recu-num")} :</span>{" "}
                            {(transaction?.reservation?.canceled ||
                                transaction?.reservation?.status[
                                    transaction?.reservation?.status.length - 1
                                ]?.status === EStatus.CANCELLED ||
                                transaction?.reservation?.status[
                                    transaction?.reservation?.status.length - 1
                                ]?.status === EStatus.CANCELLED_BY_ADMIN ||
                                transaction?.reservation?.status[
                                    transaction?.reservation?.status.length - 1
                                ]?.status === EStatus.REJECTED) &&
                            isCancellation
                                ? refundedTransactonId
                                : transaction._id}
                        </li>
                        <li>
                            <span>Date :</span>{" "}
                            {(transaction?.reservation?.canceled ||
                                transaction?.reservation?.status[
                                    transaction?.reservation?.status.length - 1
                                ]?.status === EStatus.CANCELLED ||
                                transaction?.reservation?.status[
                                    transaction?.reservation?.status.length - 1
                                ]?.status === EStatus.CANCELLED_BY_ADMIN ||
                                transaction?.reservation?.status[
                                    transaction?.reservation?.status.length - 1
                                ]?.status === EStatus.REJECTED) &&
                            isCancellation
                                ? moment(
                                      new Date(
                                          refundedTransactonCreatedAt ||
                                              new Date()
                                      )
                                  ).format("DD/MM/YYYY hh:mm A")
                                : moment(
                                      new Date(
                                          transaction?.createdAt || new Date()
                                      )
                                  ).format("DD/MM/YYYY hh:mm A")}
                        </li>
                    </ul>
                    <Grid
                        container
                        rowSpacing={2}
                        style={{ marginBottom: 24 }}
                        spacing={2}
                    >
                        <Grid item xs={12} md={7}>
                            <ul className={classes.info}>
                            <li>
                                <span>{t("recu.labels.pays")} :</span>{" "}
                                {transaction?.reservation?.announce?.property?.address?.country?.name || "Unknown"}
                            </li>

                                <li>
                                    {getDayNumber(
                                        transaction?.reservation?.dateCheckIn ||
                                            "",
                                        transaction?.reservation
                                            ?.dateCheckOut || ""
                                    )}{" "}
                                    {t("recu.labels.nuitee-a")}{" "}
                                    {
                                        transaction?.reservation?.announce
                                            ?.property?.address?.city?.name || "Unknown"
                                    }{" "}
                                </li>
                                <li>
                                    <span>{t("recu.labels.voyageur")} :</span>{" "}
                                    {`${
                                        transaction.reservation?.traveller
                                            .lastName ?? ""
                                    } ${
                                        transaction.reservation?.traveller
                                            .firstName ?? ""
                                    }`}
                                </li>
                            </ul>
                        </Grid>
                        <Grid
                            item
                            xs={12}
                            md={5}
                            className={classes.marginOnMd}
                        >
                            {(transaction?.reservation?.canceled ||
                                transaction?.reservation?.status[
                                    transaction?.reservation?.status.length - 1
                                ]?.status === EStatus.CANCELLED ||
                                transaction?.reservation?.status[
                                    transaction?.reservation?.status.length - 1
                                ]?.status === EStatus.CANCELLED_BY_ADMIN ||
                                transaction?.reservation?.status[
                                    transaction?.reservation?.status.length - 1
                                ]?.status === EStatus.REJECTED) &&
                            isCancellation ? (
                                <>
                                    <Typography
                                        variant="h5"
                                        style={{
                                            fontWeight: "bold",
                                            marginBottom: 10,
                                        }}
                                    >
                                        {t("recu.labels.details")}
                                    </Typography>
                                    <Grid
                                        container
                                        justifyContent="space-between"
                                        style={{ marginBottom: 10 }}
                                    >
                                        <Grid item>
                                            <span
                                                style={{ fontWeight: "bold" }}
                                            >
                                                {t("label.paiement-initial")}
                                            </span>
                                        </Grid>
                                        <Grid item>
                                            <span
                                                style={{ fontWeight: "bold" }}
                                            >
                                                {priceConvertedFinal}{" "}
                                                {currency.toLocaleUpperCase()}
                                            </span>
                                        </Grid>
                                    </Grid>
                                    {nbJourProm > 0 ? (
                                        <>
                                            {nbJourSimple > 0 && (
                                                <>
                                                    <Grid
                                                        container
                                                        justifyContent="space-between"
                                                        style={{
                                                            marginBottom: 10,
                                                        }}
                                                    >
                                                        <Grid item>
                                                            {t(
                                                                "label.tarif-applique"
                                                            )}
                                                        </Grid>
                                                        <Grid item>
                                                            {getTarifLabel(
                                                                tarif
                                                            )}
                                                        </Grid>
                                                    </Grid>
                                                    <Grid
                                                        container
                                                        justifyContent="space-between"
                                                        style={{
                                                            marginBottom: 10,
                                                        }}
                                                    >
                                                        <Grid item>
                                                            {priceConverted} x{" "}
                                                            {nbJourSimple}{" "}
                                                            {t(
                                                                "recu.labels.nuitees"
                                                            )}
                                                        </Grid>
                                                        <Grid item>
                                                            {totalPriceSimple}{" "}
                                                            {currency.toLocaleUpperCase()}
                                                        </Grid>
                                                    </Grid>
                                                </>
                                            )}
                                            <Grid
                                                container
                                                justifyContent="space-between"
                                                style={{ marginBottom: 10 }}
                                            >
                                                <Grid item>
                                                    {priceConvertedProm} x{" "}
                                                    {nbJourProm}{" "}
                                                    {t("recu.labels.nuitees")}{" "}
                                                    {`(-${promotionRate}%)`}
                                                </Grid>
                                                <Grid item>
                                                    {totalPriceProm}{" "}
                                                    {currency.toLocaleUpperCase()}
                                                </Grid>
                                            </Grid>
                                        </>
                                    ) : (
                                        <>
                                            <Grid
                                                container
                                                justifyContent="space-between"
                                                style={{ marginBottom: 10 }}
                                            >
                                                <Grid item>
                                                    {t("label.tarif-applique")}
                                                </Grid>
                                                <Grid item>
                                                    {getTarifLabel(tarif)}
                                                </Grid>
                                            </Grid>
                                            <Grid
                                                container
                                                justifyContent="space-between"
                                                style={{ marginBottom: 10 }}
                                            >
                                                <Grid item>
                                                    {priceConverted} x{" "}
                                                    {getDayNumber(
                                                        transaction?.reservation
                                                            ?.dateCheckIn || "",
                                                        transaction?.reservation
                                                            ?.dateCheckOut || ""
                                                    )}{" "}
                                                    {t("recu.labels.nuitees")}
                                                </Grid>
                                                <Grid item>
                                                    {priceWithoutCleaningFees}{" "}
                                                    {currency.toLocaleUpperCase()}
                                                </Grid>
                                            </Grid>
                                        </>
                                    )}
                                    <Grid
                                        container
                                        justifyContent="space-between"
                                        style={{ marginBottom: 10 }}
                                    >
                                        <Grid item>
                                            {t(
                                                "reservation.label.frais-sejour-passe"
                                            )}{" "}
                                            :
                                        </Grid>
                                        <Grid item>
                                            {passedDaysFees}{" "}
                                            {currency.toLocaleUpperCase()}
                                        </Grid>
                                    </Grid>
                                    <Grid
                                        container
                                        justifyContent="space-between"
                                        style={{ marginBottom: 10 }}
                                    >
                                        <Grid item>
                                            {t(
                                                "reservation.label.frais-penalites"
                                            )}{" "}
                                            :
                                        </Grid>
                                        <Grid item>
                                            {penaltyDaysFees}{" "}
                                            {currency.toLocaleUpperCase()}
                                        </Grid>
                                    </Grid>
                                    <Grid
                                        container
                                        justifyContent="space-between"
                                        style={{ marginBottom: 10 }}
                                    >
                                        <Grid item>
                                            {t(
                                                "reservation.label.frais-de-nettoyage"
                                            )}{" "}
                                            :
                                        </Grid>
                                        <Grid item>
                                            {getRefundTypeFact(
                                                new Date(
                                                    transaction?.reservation?.dateCheckIn
                                                ),
                                                transaction?.reservation
                                                    ?.announce.freeRefundDay,
                                                transaction?.reservation
                                                    ?.status[
                                                    transaction?.reservation
                                                        ?.status.length - 1
                                                ]?.date
                                            ) === ERefundType.PreStay &&
                                            transaction?.reservation?.status?.some(
                                                (status: any) =>
                                                    status.status ===
                                                    EStatus.APPROVED
                                            )
                                                ? cleaningFees
                                                : 0}{" "}
                                            {currency.toUpperCase()}
                                        </Grid>
                                    </Grid>
                                    <Grid
                                        container
                                        justifyContent="space-between"
                                        style={{ marginBottom: 10 }}
                                    >
                                        <Grid item>
                                            {t(
                                                "reservation.label.frais-de-reservation"
                                            )}{" "}
                                            :
                                        </Grid>
                                        <Grid item>
                                            {reversalFeesAmount}{" "}
                                            {currency.toLocaleUpperCase()}
                                        </Grid>
                                    </Grid>
                                    <Divider
                                        style={{
                                            marginTop: 10,
                                            marginBottom: 10,
                                        }}
                                    />
                                    <Grid
                                        container
                                        justifyContent="space-between"
                                    >
                                        <Grid item>
                                            {t(
                                                "reservation.label.votre-remboursement-total"
                                            )}{" "}
                                            ({currency.toLocaleUpperCase()})
                                        </Grid>
                                        <Grid item>
                                            {travellerRefundFinal}{" "}
                                            {currency.toLocaleUpperCase()}
                                        </Grid>
                                    </Grid>
                                </>
                            ) : (
                                <>
                                    <Typography
                                        variant="h5"
                                        style={{
                                            fontWeight: "bold",
                                            marginBottom: 10,
                                        }}
                                    >
                                        {t("recu.labels.details")}
                                    </Typography>
                                    {nbJourProm > 0 ? (
                                        <>
                                            {nbJourSimple > 0 && (
                                                <>
                                                    <Grid
                                                        container
                                                        justifyContent="space-between"
                                                        style={{
                                                            marginBottom: 10,
                                                        }}
                                                    >
                                                        <Grid item>
                                                            {t(
                                                                "label.tarif-applique"
                                                            )}
                                                        </Grid>
                                                        <Grid item>
                                                            {getTarifLabel(
                                                                tarif
                                                            )}
                                                        </Grid>
                                                    </Grid>
                                                    <Grid
                                                        container
                                                        justifyContent="space-between"
                                                        style={{
                                                            marginBottom: 10,
                                                        }}
                                                    >
                                                        <Grid item>
                                                            {priceConverted} x{" "}
                                                            {nbJourSimple}{" "}
                                                            {t(
                                                                "recu.labels.nuitees"
                                                            )}
                                                        </Grid>
                                                        <Grid item>
                                                            {totalPriceSimple}{" "}
                                                            {currency.toLocaleUpperCase()}
                                                        </Grid>
                                                    </Grid>
                                                </>
                                            )}
                                            <Grid
                                                container
                                                justifyContent="space-between"
                                                style={{ marginBottom: 10 }}
                                            >
                                                <Grid item>
                                                    {priceConvertedProm} x{" "}
                                                    {nbJourProm}{" "}
                                                    {t("recu.labels.nuitees")}{" "}
                                                    {`(-${promotionRate}%)`}
                                                </Grid>
                                                <Grid item>
                                                    {totalPriceProm}{" "}
                                                    {currency.toLocaleUpperCase()}
                                                </Grid>
                                            </Grid>
                                        </>
                                    ) : (
                                        <>
                                            <Grid
                                                container
                                                justifyContent="space-between"
                                                style={{ marginBottom: 10 }}
                                            >
                                                <Grid item>
                                                    {t("label.tarif-applique")}
                                                </Grid>
                                                <Grid item>
                                                    {getTarifLabel(tarif)}
                                                </Grid>
                                            </Grid>
                                            <Grid
                                                container
                                                justifyContent="space-between"
                                                style={{ marginBottom: 10 }}
                                            >
                                                <Grid item>
                                                    {priceConverted} x{" "}
                                                    {getDayNumber(
                                                        transaction?.reservation
                                                            ?.dateCheckIn || "",
                                                        transaction?.reservation
                                                            ?.dateCheckOut || ""
                                                    )}{" "}
                                                    {t("recu.labels.nuitees")}
                                                </Grid>
                                                <Grid item>
                                                    {priceWithoutCleaningFees}{" "}
                                                    {currency.toLocaleUpperCase()}
                                                </Grid>
                                            </Grid>
                                        </>
                                    )}
                                    <Grid
                                        container
                                        justifyContent="space-between"
                                        style={{ marginBottom: 10 }}
                                    >
                                        <Grid item>
                                            {t("label.frais-de-nettoyage")}
                                        </Grid>
                                        <Grid item>
                                            {cleaningFees}{" "}
                                            {currency.toLocaleUpperCase()}
                                        </Grid>
                                    </Grid>
                                    <Grid
                                        container
                                        justifyContent="space-between"
                                    >
                                        <Grid item>
                                            {t("label.frais-de-service")}
                                        </Grid>
                                        <Grid item>
                                            {priceServiceConverted}{" "}
                                            {currency.toLocaleUpperCase()}
                                        </Grid>
                                    </Grid>
                                    <Divider
                                        style={{
                                            marginTop: 10,
                                            marginBottom: 10,
                                        }}
                                    />
                                    <Grid
                                        container
                                        justifyContent="space-between"
                                    >
                                        <Grid item>
                                            Total (
                                            {currency.toLocaleUpperCase()})
                                        </Grid>
                                        <Grid item>
                                            {priceConvertedFinal}{" "}
                                            {currency.toLocaleUpperCase()}
                                        </Grid>
                                    </Grid>
                                </>
                            )}
                        </Grid>
                        <Grid item xs={12} md={7}>
                            <ul className={classes.info}>
                                <li>
                                    {moment(
                                        transaction?.reservation?.dateCheckIn
                                    ).format("DD/MM/YYYY")}{" "}
                                    -{" "}
                                    {moment(
                                        transaction?.reservation?.dateCheckOut
                                    ).format("DD/MM/YYYY")}
                                </li>
                                <li>
                                    <span>
                                        {t("recu.labels.nom-de-l-annonce")} :{" "}
                                    </span>
                                    {
                                        transaction?.reservation?.announce
                                            ?.property?.name
                                    }
                                </li>
                                <li>
                                    <span>
                                        {t("recu.labels.id-reservation")} :{" "}
                                    </span>
                                    {transaction?.reservation?._id}
                                </li>
                                <li>
                                    <span>
                                        {t("label.reference-de-la-transaction")}{" "}
                                        :{" "}
                                    </span>
                                    {(transaction?.reservation?.canceled ||
                                        transaction?.reservation?.status[
                                            transaction?.reservation?.status
                                                .length - 1
                                        ]?.status === EStatus.CANCELLED ||
                                        transaction?.reservation?.status[
                                            transaction?.reservation?.status
                                                .length - 1
                                        ]?.status ===
                                            EStatus.CANCELLED_BY_ADMIN ||
                                        transaction?.reservation?.status[
                                            transaction?.reservation?.status
                                                .length - 1
                                        ]?.status === EStatus.REJECTED) &&
                                    isCancellation
                                        ? refundedTransactonPaymentID
                                        : paymentID}
                                </li>
                                {services.length > 0 && (
                                    <>
                                        <li>{t("label.frais-de-service")}</li>
                                        {services.map((service) => {
                                            return (
                                                <li key={service._id}>
                                                    {" "}
                                                    {service.name} :{" "}
                                                    {service.description}
                                                </li>
                                            );
                                        })}
                                    </>
                                )}
                            </ul>
                        </Grid>
                        <Grid item xs={12} md={5} className={classes.marginOnMd}>
                            <Typography variant="h5" style={{ fontWeight: "bold", marginBottom: 10 }}>
                                {t("recu.labels.paiements")}
                            </Typography>

                            {/* Payment Details Section */}
                            {transaction?.reservation?.isAdvancePayment ? (
                                <>
                                    {/* Advance Payment */}
                                    <Grid container justifyContent="space-between" style={{ marginBottom: 8 }}>
                                        <Grid item style={{ maxWidth: 260 }}>
                                            <div>
                                                {t("reservation.label.advance-payment")} ({transaction?.method})
                                                {transaction?.method === EPaymentMethod.Paypal && transaction?.paymentEmail 
                                                    ? ` (${transaction.paymentEmail})` 
                                                    : ""}
                                            </div>
                                            <div>
                                                <small style={{ color: "#999" }}>
                                                    {dateToStringDDMMYYYY(new Date(transaction?.createdAt || new Date()))}
                                                </small>
                                            </div>
                                        </Grid>
                                        <Grid item>
                                            {formatCurrency(
                                                transaction.reservation.advancePaymentAmount || 0,
                                                currency
                                            )}
                                        </Grid>
                                    </Grid>

                                    {/* Remaining Amount */}
                                    <Grid container justifyContent="space-between" style={{ marginBottom: 8 }}>
                                        <Grid item style={{ maxWidth: 260 }}>
                                        <div>
                                            {t("reservation.label.remaining-amount")}
                                            {` (${t("reservation.label.paid-in-cash")})`}
                                        </div>
                                            <div>
                                                <small style={{ color: "#999" }}>
                                                    {t("reservation.label.payment-due-date")}:{" "}
                                                    {moment(transaction.reservation.dateCheckIn).format("DD/MM/YYYY")}
                                                </small>
                                            </div>
                                        </Grid>
                                        <Grid item>
                                            {formatCurrency(
                                                transaction.reservation.remainingAmount || 0,
                                                currency
                                            )}
                                        </Grid>
                                    </Grid>
                                </>
                            ) : (
                                /* Original Full Payment Display */
                                Number(priceConvertedFinal) - Number(priceConvertedFinalFromTransaction) > 0 ? (
                                    <Grid container justifyContent="space-between">
                                        <Grid item style={{ maxWidth: 260 }}>
                                            <div>
                                                {transaction?.method}{" "}
                                                {transaction?.method === EPaymentMethod.Paypal
                                                    ? transaction?.paymentEmail
                                                    : ""}
                                            </div>
                                            <div>
                                                <small style={{ color: "#999" }}>
                                                    {dateToStringDDMMYYYY(
                                                        new Date(transaction?.createdAt || new Date())
                                                    )}
                                                </small>
                                            </div>
                                        </Grid>
                                        {renderPaymentAmount()} {/* Reused payment amount display logic */}
                                        {Number(priceCreditFromTransaction) > 0 && (
                                            <Grid container justifyContent="space-between">
                                                <Grid item>{t('label.paye-par-credit')}</Grid>
                                                <Grid item>
                                                    {formatCurrency(Number(priceCreditFromTransaction), currency)}
                                                </Grid>
                                            </Grid>
                                        )}
                                    </Grid>
                                ) : (
                                    <Grid container justifyContent="space-between">
                                        <Grid item style={{ maxWidth: 260 }}>
                                            <div>
                                                {transaction?.method}{" "}
                                                {transaction?.method === EPaymentMethod.Paypal
                                                    ? transaction?.paymentEmail
                                                    : ""}
                                            </div>
                                            <div>
                                                <small style={{ color: "#999" }}>
                                                    {dateToStringDDMMYYYY(
                                                        new Date(transaction?.createdAt || new Date())
                                                    )}
                                                </small>
                                            </div>
                                        </Grid>
                                        {renderPaymentAmount()} {/* Reused payment amount display logic */}
                                    </Grid>
                                )
                            )}

                            <Divider style={{ marginTop: 10, marginBottom: 10 }} />

                            {/* Total Amount Section */}
                            <Grid container justifyContent="space-between">
                                <Grid item>
                                    {(transaction?.reservation?.canceled ||
                                        isCancellationStatus(transaction?.reservation?.status)) && isCancellation
                                        ? t("recu.labels.montant-rembourse")
                                        : t("recu.labels.montant-paye")}{" "}
                                    ({currency.toLocaleUpperCase()})
                                </Grid>
                                <Grid item>

                                {formatCurrency(
                                (transaction?.reservation?.canceled || isCancellationStatus(transaction?.reservation?.status)) && isCancellation
                                    ? travellerRefundFinal
                                    : transaction?.reservation?.isAdvancePayment
                                    ? (Number(priceConvertedFinal) - Number(transaction?.reservation?.advancePaymentAmount))
                                    : Number(priceConvertedFinal),
                                currency
                                )}
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                    <div style={{ marginBottom: 24 }}>
                        
                        
                        <Typography
                            variant="h5"
                            style={{ fontWeight: "bold", marginBottom: 10 }}
                        >
                            {t("recu.labels.conditions-d-annulation")}
                        </Typography>
                        {transaction?.reservation?.announce?.remboursable==="noremboursable" ? 
                        (<>
                            <Typography>
                               - {t("annonce.not-remb1")} {" "}
                               {transaction?.reservation?.announce?.notRemboursable1}{" "}
                               {t("annonce.not-remb2")}
                           </Typography>{" "}
                           <br />
                           <Typography>
                               - {t("annonce.not-remb3")}{" "}
                               {transaction?.reservation?.announce?.notRemboursable1}{" "}
                               {t("annonce.not-remb4")}
                           </Typography>
                       </>)
                        :
                        (<>
                        <Typography>
                            - {t("recu.labels.refundItem11")} 12:00 pm{" "}
                            {t("recu.labels.refundItem12")}{" "}
                            {moment(transaction?.reservation?.dateCheckIn)
                                .subtract(
                                    transaction?.reservation?.announce
                                        ?.freeRefundDay,
                                    "days"
                                )
                                .format("DD/MM/YYYY")}{" "}
                            {t("recu.labels.refundItem13")}
                        </Typography>
                        <Typography>
                            - {t("recu.labels.refundItem21")}{" "}
                            {moment(
                                transaction?.reservation?.dateCheckIn
                            ).format("DD/MM/YYYY")}{" "}
                            {t("recu.labels.refundItem22")}{" "}
                            {transaction.reservation?.announce
                                ?.penaltyDayFees ?? "0"}{" "}
                            {t("recu.labels.refundItem23")}
                        </Typography>
                        <Typography>
                            - {t("recu.labels.refundItem31")}{" "}
                            {transaction.reservation?.announce
                                ?.penaltyDayFeesAfterBookingStarted ?? "0"}{" "}
                            {t("recu.labels.refundItem32")}
                        </Typography></>)}
                    </div>
                    {/*<div style={{ marginBottom: 24 }}>
                        <Typography
                            variant="h5"
                            style={{ fontWeight: "bold", marginBottom: 10 }}
                        >
                            {t("recu.labels.services-fournis-par")}
                        </Typography>
                        <Typography>AfriqPnB Cameroon SAS</Typography>
                        <Typography>BP 15514 Akwa, Douala Cameroon</Typography>
                        <Typography>RCCM: RC/DLBB/2021/B/989</Typography>
                        <Typography>
                            <a href="https://afriqpnb.com">www.afriqpnb.com</a>
                        </Typography>
                    </div> */}
                </div>
            )}
        </>
    );
}

const style = makeStyles((theme) =>
    createStyles({
        container: {
            marginLeft: 40,
            maxWidth: 900,
            paddingTop: 40,
            paddingBottom: 40,
            [theme.breakpoints.down("xs")]: {
                width: "calc(100vw - 20px)",
                paddingTop: 10,
                marginLeft: 0,
            },
        },
        logo: {
            width: "auto",
            height: 96,
            display: "block",
        },
        info: {
            listStyle: "none",
            margin: 0,
            padding: 0,
            "& li": {
                marginBottom: 16,
            },
        },
        marginOnMd: {
            [theme.breakpoints.down("md")]: {
                marginBottom: 24,
            },
        },
        loading: {
            width: "100%",
            minHeight: "40vh",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
        },
    })
);
